import { render, staticRenderFns } from "./incl-apotheke-children.vue?vue&type=template&id=3e167eec"
import script from "./incl-apotheke-children.vue?vue&type=script&lang=js"
export * from "./incl-apotheke-children.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports